import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { findBatch } from '../utils';
import immer from "./immer"
let useFacultyOptionsStore = (set, get) => ({
    courses: [],
    firstBatch: null,
    getDegrees: () => {
        const courses = get().courses;
        console.log("Rendering degrees...");
        const degs = {
            "none": {
                _id: "none",
                name: "NONE"
            }
        };
        for (const c of courses) {
            degs[c.section.degree._id] = c.section.degree;
        }
        return Object.values(degs);
    },
    getBranches: (degree) => {
        if (!degree) {
            return [{
                "none": {
                    _id: "none",
                    name: "NONE"
                }
            }];
        }
        const courses = get().courses;
        console.log("Rendered branches");
        const branches = {
            "none": {
                _id: "none",
                name: "NONE"
            }
        };
        for (const c of courses) {
            if (c.section.degree._id.toString() === degree.toString()) {
                branches[c.section.branch._id] = c.section.branch;
            }
        }
        return Object.values(branches);
    },
    getYears: ({ branch, degree }) => {
        console.log('Rendering years...');
        const years = get().courses.filter(c => c.section.degree._id.toString() === degree && c.section.branch._id.toString() === branch).map(a => a.section.year);
        console.log([...new Set(years)]);
        const none = ['none'];
        return [...none, ...new Set(years)];
    },
    getSems: ({ branch, year }) => {
        console.log('Rendering sems...');
        const sem = get().courses.filter(c => c.section.branch._id.toString() === branch && c.section.year.toString() === year).map(a => a.section.sem);
        const none = ['none'];
        const a = [...new Set(sem)].sort();
        console.log(none.concat(a));
        return none.concat(a);
    },
    getSections: ({ branch, year, sem }) => {
        console.log(branch, year, sem);
        if (!branch || !year || !sem) {
            return [{
                "none": {
                    _id: "none",
                    name: "NONE"
                }
            }];
        }
        const courses = get().courses;
        console.log("Rendered sections...");
        const sections = {
            "none": {
                _id: "none",
                name: "NONE"
            }
        };
        for (const c of courses) {
            if (c.section.branch._id.toString() === branch && c.section.year.toString() === year.toString() && c.section.sem.toString() === sem.toString()) {
                sections[c.section._id] = c.section;
            }
        }
        return Object.values(sections);
    },
    getSubjects: (section) => {
        console.log('Rendering subjects...');
        const a = get().courses.filter(c => c.section._id.toString() === section).map(c => c.subject);
        return [{ _id: "none", name: "NONE" }, ...a]
    },
    getCurrentBatch: ({ year, section }) => {
        const sec = get().courses.filter(c => c.section._id.toString() === section && c.section.year.toString() === year)[0];
        if (!sec || !year) {
            return ["none"];
        }
        const eoa = sec.section.branch.eoa.filter(e => e.year.toString() === year)[0];
        const cur_batch = eoa.currentBatch;
        console.log(cur_batch);
        return ["none", cur_batch];
    },
    getBatches: (year, section, degree) => {
        const batches = [];
        const sec = get().courses.filter(c => c.section._id.toString() === section && c.section.year.toString() === year.toString())[0];
        if (!sec) {
            return [];
        }
        const dur = sec.section.degree.duration;
        const firstBatch = get().firstBatch;
        for (let i = 0; i < dur; i++) {
            const b = firstBatch - year + 1 - i;
            batches.push(b);
        }
        return batches;
    },
    addAllCourses: (courses) => set((state) => void (state.courses = courses))
});
useFacultyOptionsStore = devtools(useFacultyOptionsStore, { name: "facultyOptions" });
useFacultyOptionsStore = immer(useFacultyOptionsStore);
export default create(useFacultyOptionsStore);
